import React from 'react';
import { DropdownButton, Tooltip } from '@ihsm/ui-shared';
import { JOB_DROPDOWN_OPTIONS } from '../../constants';
import { JobItem } from '../../types';
import { JobStatusCell } from '../JobStatusCell';
import { JobTypeCell } from '../JobTypeCell';
import './JobsRow.scss';

export type JobsRowProps = {
  jobItem: Partial<JobItem>;
  onViewReport: () => void;
  onDropdownChange: (option: string) => void;
};

export const JobsRow: React.FC<JobsRowProps> = ({
  jobItem,
  onDropdownChange,
  onViewReport,
}): JSX.Element => {
  const {
    duration,
    name,
    description,
    progressRate,
    started,
    status,
    type,
    valuationDate,
    errors,
  } = jobItem;

  return (
    <div className="job-row">
      {name ? (
        <div data-span="3" className="job-row__item">
          <div className="job-row__item-content">
            <Tooltip dottedText tip={description}>
              {name}
            </Tooltip>
          </div>
        </div>
      ) : null}

      {type ? (
        <div data-span="1" className="job-row__item">
          <div className="job-row__item-content">
            <JobTypeCell type={type} />
          </div>
        </div>
      ) : null}

      {valuationDate ? (
        <div data-span="2" className="job-row__item">
          <div className="job-row__item-content">{valuationDate}</div>
        </div>
      ) : null}

      {started ? (
        <div data-span="2" className="job-row__item">
          <div className="job-row__item-content">{started}</div>
        </div>
      ) : null}

      {duration ? (
        <div data-span="1" className="job-row__item">
          <div className="job-row__item-content">{duration}</div>
        </div>
      ) : null}

      {status ? (
        <div data-span="2" className="job-row__item">
          <div className="job-row__item-status">
            <JobStatusCell
              status={status}
              progressRate={progressRate}
              errors={errors}
            />
          </div>

          <div className="job-row__item-status-buttons">
            <DropdownButton
              className="job-row-dropdown-button"
              buttonText="View Report"
              onButtonClick={() => onViewReport()}
              onChange={(option) => onDropdownChange(option)}
              options={JOB_DROPDOWN_OPTIONS}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};
